import { useState, useEffect } from "react";
import {
  useCourseOptions,
  useModuleByIdOptions,
  useRoleOptions,
  useTopicByIdOptions,
} from "../../hooks/dropdownOptions";

export const useFormConfig = (initialFormData, mode) => {
  const initialCourseId = initialFormData?.courseId || "";
  const initialModuleId = initialFormData?.moduleId || "";
  const initialTopicId = initialFormData?.topicId || "";
  const [selectedCourseId, setSelectedCourseId] = useState(initialCourseId);
  const [selectedModuleId, setSelectedModuleId] = useState(initialModuleId);
  const [selectedQuizType, setSelectedQuizType] = useState(initialFormData?.quizType || "");
  const courseOptions = useCourseOptions();
  const moduleOptions = useModuleByIdOptions(selectedCourseId);
  const topicOptions = useTopicByIdOptions(selectedModuleId);
  const roleOptions = useRoleOptions();

  useEffect(() => {
    if (initialCourseId) {
      setSelectedCourseId(initialCourseId);
    }
    if (initialModuleId) {
      setSelectedModuleId(initialModuleId);
    }
  }, [initialCourseId, initialModuleId]);

  const titleFieldType = mode === "update" ? "text" : "inputtranslation";
  const fieldConfig = [
    {
      key: "title",
      label: "Quiz Title",
      type: titleFieldType,
      placeholder: "Enter quiz title",
      required: true,
    },
    {
      key: "quizType",
      label: "Quiz Type",
      type: "dropdown",
      options: [
        { label: "Regular", value: "regular" },
        { label: "Post Assessment", value: "post assessment" },
        { label: "Pre Assessment", value: "pre assessment" },
      ],
      placeholder: "Select a Quiz Type",
      required: true,
      onChange: (e) => {
        setSelectedQuizType(e.value);
      },
    },
    {
      key: "courseId",
      label: "Course",
      type: "dropdown",
      options: courseOptions,
      placeholder: "Select a course",
      required: true,
      onChange: (e) => {
        setSelectedCourseId(e.value);
        setSelectedModuleId("");
      },
    },
    {
      key: "moduleId",
      label: "Module",
      type: "dropdown",
      options: moduleOptions,
      placeholder: "Select a Module",
      required: true,
      onChange: (e) => {
        setSelectedModuleId(e.value);
      },
    },
    {
      key: "topicId",
      label: "Topic",
      type: "dropdown",
      options: topicOptions,
      placeholder: "Select a Topic",
      required: true,
    },
    {
      key: "totalQuestions",
      label: "Total Question",
      type: "text",
      placeholder: "Enter Total Question",
      required: true,
    },
    {
      key: "passingCriteria",
      label: "Passing Criteria",
      type: "text",
      placeholder: " Enter No.Of Correct Answers",
      required: true,
    },
    {
      key: "roleIds",
      label: "Role",
      type: "multiselect",
      options: roleOptions,
      placeholder: "Select a Role",
      required: true,
    },
    {
      key: "publishDate",
      label: "Scheduled Publish Date",
      type: "calendar",
      required: false,
      placeholder: "Select a Scheduled Publish Date",
    },
    {
      key: "startDate",
      label: "Start Date",
      type: "calendar",
      required: true,
      placeholder: "Select a Start Date",
    },
  ];
  if (selectedQuizType === "regular") {
    fieldConfig.push({
      key: "endDate",
      label: "End Date",
      type: "calendar",
      required: true,
      placeholder: "Select an End Date",
    });
  }

  return {
    quizForm: {
      formTitle: "Quiz",
      initialFormData: {
        title: "",
        courseId: mode === "update" ? initialCourseId : "",
        moduleId: mode === "update" ? initialModuleId : "",
        topicId: mode === "update" ? initialTopicId : "",
        roleIds: [],
        quizType: "",
        totalQuestions: "",
        startDate: "",
        endDate: "",
        publishDate: "",
        passingCriteria: "",
      },
      fieldConfig,
    },
  };
};
